import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IssueLocationMapService } from './issue-location-map.service';

export interface IssueContext {
  detectedRoute: string;      // router.url
  detectedScreen: string;     // cadena de breadcrumbs "A › B"
  projectId?: number;
  projectName?: string;
  userAgent: string;
  viewport: string;
  suggestedModuleName?: string;
  suggestedSubmoduleName?: string;
}

@Injectable({ providedIn: 'root' })
export class IssueContextService {
  constructor(private router: Router, private map: IssueLocationMapService) {}

  capture(): IssueContext {
    const detectedRoute = this.router.url;
    const detectedScreen = this.readBreadcrumbChain();
    const project = this.readCurrentProject();
    const suggestion = this.map.resolve(detectedRoute);

    return {
      detectedRoute,
      detectedScreen,
      projectId: project?.projectId,
      projectName: project?.name,
      userAgent: navigator.userAgent,
      viewport: `${window.innerWidth}x${window.innerHeight}`,
      suggestedModuleName: suggestion?.module,
      suggestedSubmoduleName: suggestion?.submodule,
    };
  }

  /** Replica la técnica de AppBreadcrumb: recorrer snapshot.root leyendo data['breadcrumb']. */
  private readBreadcrumbChain(): string {
    const labels: string[] = [];
    let parentLabel: any = null;

    const walk = (r: any) => {
      const bc = r.data?.['breadcrumb'];
      if (bc && bc !== parentLabel) { labels.push(bc); parentLabel = bc; }
      if (r.firstChild) walk(r.firstChild);
    };

    walk(this.router.routerState.snapshot.root);
    return labels.join(' › ');
  }

  private readCurrentProject(): { projectId: number; name: string } | null {
    try {
      const s = localStorage.getItem('current-project');
      return s ? JSON.parse(s) : null;
    } catch {
      return null;
    }
  }
}
